import { memo } from 'react';
import { classnames } from '@/libs/utils';
import {
  cssToPreset,
  isFontSizePreset,
  FontSizePreset,
  FONT_SIZE_PRESETS
} from '@/player-config/src/types/speaker-label-font-size';

interface Props {
  value: string | FontSizePreset;
  onChange: (value: FontSizePreset) => void;
}

const SpeakerLabelFontSizeSelector = memo(({ value, onChange }: Props) => {
  const currentPreset: FontSizePreset = isFontSizePreset(value) ? value : cssToPreset(value);

  return (
    <div className="flex h-6 w-[180px] flex-row items-start rounded-lg bg-gray-100 p-0.5">
      {FONT_SIZE_PRESETS.map(preset => (
        <button
          key={preset}
          data-testid={`font-size-${preset}`}
          className={classnames(
            'flex h-5 grow flex-row items-center justify-center rounded-md p-2 text-[10px] font-medium leading-3 text-black focus:outline-none',
            currentPreset === preset ? 'bg-white shadow-sm' : ''
          )}
          onClick={() => onChange(preset)}
        >
          {preset}
        </button>
      ))}
    </div>
  );
});

SpeakerLabelFontSizeSelector.displayName = 'SpeakerLabelFontSizeSelector';

export default SpeakerLabelFontSizeSelector;
